var flipCards = document.querySelectorAll('.tastingNotes__card');

if (flipCards) {
    flipCards.forEach((card) => {
        card.addEventListener('click', handleFlipCard);
    });
}

function handleFlipCard(e) {
    var card = e.target.parentElement;
    if (card.classList.contains('tastingNotes__card--active')) {
        card.classList.remove('tastingNotes__card--active');
    } else {
        card.classList.add('tastingNotes__card--active');
    }
}